import { render, staticRenderFns } from "./Pictureshow.vue?vue&type=template&id=4fe1f608"
import script from "./Pictureshow.vue?vue&type=script&lang=js"
export * from "./Pictureshow.vue?vue&type=script&lang=js"
import style0 from "./Pictureshow.vue?vue&type=style&index=0&id=4fe1f608&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_1b3fe109433f9fe6108f2b5a977879df/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports